function parseDateTime(value) {
  if (!value) return null;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function validateEventDates({ startAt, endAt, doorsAt, applicationDeadline }) {
  const start = parseDateTime(startAt);
  if (!start) return "eventStartInvalid";

  if (endAt) {
    const end = parseDateTime(endAt);
    if (!end) return "eventEndInvalid";
    if (end <= start) return "eventEndBeforeStart";
  }

  if (doorsAt) {
    const doors = parseDateTime(doorsAt);
    if (!doors) return "eventDoorsInvalid";
    if (doors > start) return "eventDoorsAfterStart";
  }

  if (applicationDeadline) {
    const deadline = parseDateTime(`${applicationDeadline}T23:59:59`);
    if (!deadline) return "eventDeadlineInvalid";
    if (deadline >= start) return "gigDeadlineInvalid";
  }

  return "";
}
